var TSGMap = {
    // main map
    map: null,

    // listy danych obieków i tras
    lists: {},
    tracks: {},
    markers: [],

    // small preview maps
    previewMaps: {},

    // obiekty na mapie
    objects: {},

    infoView: null,
    track: null,
    trackData: null,
	elevationPoints : null,

    pinIconDefault: '/dist/images/pin-default.png',
    pinIconTemplate: '/media/category/{id}/marker-xss.png',

    itemPopupTemplate: '<div class="map-popup"><b>{name}</b><br /><a href="{url}">więcej</a></div>',

    mapStyle: [
        {"featureType":"all","stylers":[{"saturation":0},{"hue":"#e7ecf0"}]},
        {"featureType":"road","stylers":[{"saturation":-70}]},
        {"featureType":"transit","stylers":[{"visibility":"off"}]},
        {"featureType":"poi","stylers":[{"visibility":"off"}]},
        {"featureType":"water","stylers":[{"visibility":"simplified"},
            {"saturation":-60}]}
    ],


    options: function (options) {
        if (options == undefined)
            options = {};
        return jQuery.extend({
            zoom: 14,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            streetViewControl: false,
            mapTypeControl: false,
        }, options);
    },

    addMarker: function (center, title, map, c) {
        if (map == undefined)
            map = this.map;
        var opts = {
            position: center,
            map: map,
            title: title
        };

        if (c != undefined) {
            if (isNaN(c))
                opts.icon = TSGMap.pinIconDefault;
            else
                opts.icon = TSGMap.pinIconTemplate.replace('{id}', category);
        }
        var m = new google.maps.Marker(opts);
        TSGMap.markers.push(m);
        return m;
    },

    addObjects: function (objects, map) {
        if (map == undefined)
            map = this.map;
        for (var i in objects) {
            TSGMap.addObject(objects[i], map);
        }
    },

    addObject: function (o, map, disableMarkerInit) {

        if (map == undefined)
            map = this.map;
        var opts = {
            position: new google.maps.LatLng(o.lat, o.lon),
            map: map,
            title: o.name
        };

        var category = o.c ? o.c : o.category_id;
        if (o.icon) {
            opts.icon = o.icon;
        } else  if (category) {
            opts.icon = TSGMap.pinIconTemplate.replace('{id}', category);
        } else {
            opts.icon = TSGMap.pinIconDefault;
        }
        var marker = new google.maps.Marker(opts);
        marker.item_id = o.id;
        o.marker = marker;
        TSGMap.objects[o.id] = o;
        if (!disableMarkerInit) {
            this.initMarker(marker);
        }
        return marker;
    },

    initMarker: function (marker) {
        google.maps.event.addListener(marker, 'click', function () {
            TSGMap.markerClicked(marker);
        });
    },

    markerClicked: function (marker, zoom) {
        var o = TSGMap.objects[marker.item_id];
        var html = TSGMap.itemPopupTemplate;

        for (var i in o) {
            html = html.replace('{' + i + '}', o[i]);
        }

        TSGMap.infoView.setContent(html);
        TSGMap.infoView.setPosition(new google.maps.LatLng(o.lat, o.lon));
        TSGMap.infoView.open(TSGMap.map);
    },

    clearObjects: function () {
        for (var j in TSGMap.objects) {
            TSGMap.objects[j].marker.setMap(null);
        }
        TSGMap.objects = {};
    },

    setCenter: function (lat, lon) {
        TSGMap.map.setCenter(new google.maps.LatLng(lat, lon));
    },

    fitObjects: function (map, padding) {
        if (map == undefined)
            map = TSGMap.map;
        var objects = TSGMap.objects;
        var count = 0;
        var bounds = new google.maps.LatLngBounds();
        for (var i in objects) {
            bounds.extend(objects[i].marker.position);
            count++;
        }

        if (count > 0) {
            if (padding) {
                map.fitBounds(bounds, padding);
            } else {
                map.fitBounds(bounds);
            }
        }
    },

    clearTrack: function () {
        if (TSGMap.track) {
            TSGMap.track.setMap(null);
            TSGMap.track = null;
            TSGMap.trackData = null;
        }
    },

    addTrack: function (track, map, fit) {
        if (map == undefined || map == null)
            map = this.map;
        if (fit == undefined)
            fit = true;
        var bounds = new google.maps.LatLngBounds();
        var tripCoordinates = [];
        for (var i in track) {
            var coord = new google.maps.LatLng(track[i].lat, track[i].lon);
            tripCoordinates.push(coord);
            bounds.extend(coord);
        }
        var tripPath = new google.maps.Polyline({
            path: tripCoordinates,
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 0.7,
            strokeWeight: 4
        });
        tripPath.setMap(map);
        if (fit)
            map.fitBounds(bounds);
        TSGMap.track = tripPath;
        TSGMap.trackData = track;
        return tripPath;
    },

    addTracks : function(tracks, map, fit, withObjects) {
        if(map == undefined || map == null)
            map = this.map;
        if(fit == undefined)
            fit = true;
        var bounds = new google.maps.LatLngBounds();

        for (var j in tracks) {
            var track = tracks[j].points;
            var tripCoordinates = [];
            for(var i in track) {
                var coord = new google.maps.LatLng(track[i].lat, track[i].lon);
                tripCoordinates.push(coord);
                bounds.extend(coord);
            }
            var tripPath = new google.maps.Polyline({
                path: tripCoordinates,
                geodesic: true,
                strokeColor: '#FF0000',
                strokeOpacity: 0.7,
                strokeWeight: 4
            });
            tripPath.setMap(map);
        }

        if(fit) {
            if (withObjects) {
                bounds = bounds.union(TSGMap.objectsBounds(map));
            }
            map.fitBounds(bounds);
        }
    },

    afterInit: null
};


jQuery.fn.tsgmap = function () {
    $(this).each(function () {
        var options = TSGMap.options();
        var lat = $(this).data('latitude');
        var lon = $(this).data('longitude');
        if (lat && lon) {
            options.center = new google.maps.LatLng(lat, lon);
        }
        if ($(this).data('zoom'))
            options.zoom = $(this).data('zoom');
        if ($(this).data('scroll-wheel') != undefined)
            options.scrollwheel = $(this).data('scroll-wheel');

        options.styles = TSGMap.mapStyle;
        var map = new google.maps.Map($(this).get(0), options);
        if ($(this).data('main'))
            TSGMap.map = map;
        var title = $(this).data('title');
        if (lat && lon && title) {
            TSGMap.addMarker(new google.maps.LatLng(lat, lon), title, map, $(this).data('c'));
        }
        if ($(this).data('type') == 'list') {
            TSGMap.addObjects(TSGMap.lists[$(this).data('id')], map);
            TSGMap.fitObjects(map);
        }
        var trip = $(this).data('trip');
        if (trip) {
            $.get(trip, function (data) {
                TSGMap.addTracks(data.track, map);
                TSGMap.addObjects(data.objects, map);
            }, 'json');
        }
        $(this).data('map', map);
    });
    if (TSGMap.afterInit) {
        TSGMap.afterInit();
    }
    TSGMap.infoView = new google.maps.InfoWindow({
        pixelOffset: new google.maps.Size(0, -44)
    });
    return this;
};
